export const routeName = {
    account: 'account',
    activities: 'activities',
    adminPanel: 'admin-panel',
    categories: 'categories',
    chats: 'chats',
    claimActions: 'claimActions',
    creditTypes: 'creditTypes',
    claims: 'claims',
    confirm: 'confirm',
    contactTypes: 'contactTypes',
    contacts: 'contacts',
    create: 'create',
    details: 'details',
    domainUsers: 'domainUsers',
    domains: 'domains',
    emailChange: 'email-change',
    functionMembers: 'functionMembers',
    functions: 'functions',
    home: 'home',
    image: 'image',
    images: 'images',
    login: 'login',
    messages: 'messages',
    notices: 'notices',
    observationTypes: 'observationTypes',
    taskTypes: 'taskTypes',
    projectMembers: 'projectMembers',
    projects: 'projects',
    pageComponents: 'pageComponents',
    pages: 'pages',
    password: 'password',
    passwordChange: 'password-change',
    photos: 'photos',
    recover: 'recover',
    register: 'register',
    reports: 'reports',
    roles: 'roles',
    settings: 'settings',
    signup: 'signup',
    tasks: 'tasks',
    themes: 'themes',
    users: 'users',
}

export type TRouteName = (typeof routeName)[keyof typeof routeName];